import appCONST from 'constants/app.constants';
import tripEvents from './../config/events.constant';
import tripItemTypes from './../trip-item-types.js';


export default function TripAPI(
    $rootScope,
    $http,
    tripUtils,
    l10nService,
    toleranceHelper,
    userService,
    railAmendmentService,
) {
    'ngInject';

    return {
        isEmailExists: function(email) {
            const endpoint = `${appCONST.apiUrl}/Authorize/IsTravellerProfileExist?email=${email}`;
            return $http.get(endpoint, {noSpinner: true}).then(({data}) => data);
        },

        fetchPaymentCodes: function(searchData) {
            const config = {params: searchData, noSpinner: true};
            return $http.apiGET('/staticdata/SearchPaymentCodeDropDownValues', config)
                .then(({data}) => data);
        },

        fetchCallingCodes: function() {
            return $http.apiGET('/staticdata/GetRegionCentricCallingCodes', {cache: true})
                .then(({data}) => data);
        },

        fetchCountries: function() {
            return $http.apiGET('/staticdata/GetCountriesRegionCentric', {cache: true})
                .then(({data}) => data);
        },
        getTripStatuses: function() {
            const data = [
                {
                    Id: 1,
                    Name: 'Quote',
                },
                {
                    Id: 2,
                    Name: 'Held',
                },
                {
                    Id: 3,
                    Name: 'Confirmed',
                },
                {
                    Id: 4,
                    Name: 'Cancelled',
                },
                {
                    Id: 6,
                    Name: 'Enroute',
                },
                {
                    Id: 7,
                    Name: 'Past',
                },
                {
                    Id: 8,
                    Name: 'Pending Confirmation',
                },
            ];

            const options = [{text: l10nService.localize('All'), value: 0}];

            _.each(data, function(item) {
                options.push({text: l10nService.localize(item.Name), value: item.Id});
            });

            return options;
                },
        getRailReservationPreferenceOptions: function() {
            const MsgNum = 0;
            const params = {
                MsgNum,
            };
            return $http.apiGET('/rails/GetTicketPreferenceDetails', {params});
        },

        getRailTravelCardOptions: function(departDate) {
            const RailTravelCardRequest = {};
            RailTravelCardRequest.MsgNum = 1;
            RailTravelCardRequest.ValidFor = departDate;
            RailTravelCardRequest.TermsAndConditions = true;
            return $http.apiPOST('/rails/GetTravelCardCostDetails', RailTravelCardRequest);
        },

        fetchTripsList: function(params) {
            return $http.apiGET('/trips', {params});
        },

        findIds: function(pattern) {
            const request = {
                searchPattern: pattern,
            };
            return $http.apiGET('/trips/GetTripIds', {params: request, noSpinner: true})
                .then(function(response) {
                    return response.data;
                });
        },

        findTravellers: function(pattern) {
            const request = {
                namePart: pattern,
                includePastTrips: true,
            };
            return $http.apiGET('/trips/GetTravellers', {params: request, noSpinner: true})
                .then(function(response) {
                    return response.data;
                });
        },

        findLocations: function(pattern) {
            const request = {
                searchPattern: pattern,
            };
            return $http.apiGET('/trips/GetTripLocations', {params: request, noSpinner: true})
                .then(function(response) {
                    return response.data;
                });
        },

        validateTrip: function(tripId) {
            const params = {id: tripId};
            const amendmentParameters = railAmendmentService.getAmendmentParameters();
            if (amendmentParameters) {
                Object.assign(params, {
                    ItemType: amendmentParameters.isEuRails ? tripItemTypes.eurail : tripItemTypes.rail,
                    recommendationId: amendmentParameters.recommendationId,
                });
            }

            return $http.apiGET('/trips/validate', {params});
        },

        fetchTripCheckoutData: function(tripId) {
            const params = {id: tripId};
            const amendmentParameters = railAmendmentService.getAmendmentParameters();
            if (amendmentParameters) {
                Object.assign(params, {
                    ItemType: amendmentParameters.isEuRails ? tripItemTypes.eurail : tripItemTypes.rail,
                    recommendationId: amendmentParameters.recommendationId,
                });
            }
            if (toleranceHelper.needToOpenBookSectionForTrip(tripId)) {
                params.isBookSectionOpen = true;
            }
            return $http.apiGET('/trips/checkout', {params});
        },

        fetchTripDetailsByHashCode: function(tripId) {
            return $http.apiGET('/trips/byHash', {
                params: {
                    hashCode: tripId,
                },
            });
        },

        fetchTripDetailsWithCardData: function(tripId) {
            const params = {id: tripId};
            const amendmentParameters = railAmendmentService.getAmendmentParameters();
            if (amendmentParameters) {
                Object.assign(params, {
                    ItemType: amendmentParameters.isEuRails ? tripItemTypes.eurail : tripItemTypes.rail,
                    recommendationId: amendmentParameters.recommendationId,
                });
            }
            return $http.apiGET('/trips/byId', {params})
                .then((response) => {
                    const paymentCodes = angular.copy(response.data.PaymentCodes);
                    response.data.PaymentCodes = paymentCodes.sort(sortPaymentCodesByParent);
                    return response;
                });

            function sortPaymentCodesByParent(pc1, pc2) {
                const parent1 = pc1.ParentPaymentCodeId || 0;
                const parent2 = pc2.ParentPaymentCodeId || 0;
                return parent1 - parent2;
            }
        },

        updatedTripCosts: function({tripId, cardType, isInvoice, luggageData, recommendationId, purchaseCarbon}) {
            const requestData = {
                TripId: tripId,
                IsInvoicePayment: isInvoice,
                CreditCardTypeId: (isInvoice) ? null : cardType,
                SelectedLuggageOptions: (luggageData.length) ? luggageData : null,
                PurchaseCarbon: purchaseCarbon,
            };
            if (recommendationId) {
                Object.assign(requestData, {
                    ItemType: tripItemTypes.rail,
                    recommendationId,
                });
            }

            return $http.apiPOST('/trips/GetUpdatedTripCosts', requestData)
                .then(({data}) => data);
        },

        getPersonsToReview: function(params) {
            const requestParams = {params, noSpinner: true};
            return $http.apiGET('/Authorize/SearchUsers', requestParams);
        },

        searchApprovers: function(value, level) {
            return $http.apiGET(`/Authorize/SearchApprovers?searchString=${value}&approvalLevel=${level}`, {noSpinner: true})
                .then(({data}) => data);
        },

        checkTripAvailability: function(tripId) {
            const availabilityUrl = '/trips/CheckTripAvailability';
            const params = {tripId};
            const amendmentParameters = railAmendmentService.getAmendmentParameters();
            if (amendmentParameters) {
                Object.assign(params, {
                    ItemType: amendmentParameters.isEuRails ? tripItemTypes.eurail : tripItemTypes.rail,
                    recommendationId: amendmentParameters.recommendationId,
                });
            }
            return $http.apiGET(availabilityUrl, {params});
        },

        getRejectedFlight: function(flightId) {
            return $http.apiGET('/flights/getRejectedFlightRecommendations?tripItemFlightRecommendationId=' + flightId).then(
                function(response) {
                    return response;
                });
        },
        createTrip: function(params) {
            const tripData = tripUtils.collectTripData(params);

            return $http.apiPOST('/trips', tripData)
                .then(({data}) => {
                    createFireEventFunction(tripEvents.TRIP_CREATED)(data);
                    return data;
                });
        },

        saveTraveller: function(travellerRequestData) {
            return $http.apiPOST('/trips/saveTravellerDetails', travellerRequestData);
        },

        savePassenger: function(request) {
            return $http.apiPOST('/trips/savePassengerDetails', request);
        },

        changeTrip: function(param) {
            return $http.apiPOST('/trips/ChangeTrip', param);
        },

        sendQuote: function(quote) {
            return $http.apiPOST('/trips/ReviewQuote', quote);
        },

        sendTripToReview: function(params) {
            return $http.apiPOST('/trips/ReviewTrip', params);
        },

        removeTrip: function(params) {
            return $http.apiPOST('/trips/Cancel', params);
        },

        cancelTripItem: function(params) {
            return $http.apiPOST('/trips/CancelItem', params);
        },

        saveCreditCard: function(params) {
            return $http.apiPOST('/Authorize/SaveCreditCard', params);
        },

        updateInvalidTrip: function(requestData) {
            return $http.apiPOST('/trips/UpdateInvalidTrip', requestData);
        },

        searchTravellerProfiles: function(request = {
            SearchData: '',
            DepartmentId: userService.getUser() ? userService.getUser().Department : 0,
            TripId: '',
        }) {
            return $http.apiPOST('/Authorize/SearchTravellerProfiles', request, {noSpinner: true})
                .then(({data}) => {
                    return _.map(data, (item) => {
                        item._title = _.compact([
                            item.Title,
                            item.FirstName,
                            item.LastName,
                            '(' + item.EmailAddress + ')',
                        ]).join(' ');

                        return item;
                    });
                });
        },


        updateApprovalProcess: function(request) {
            return $http.apiPOST('/trips/UpdateApprovalProcess', request);
        },

        actionTrip: function(requestData, tripDetails) {
            const actionTripUrl = '/trips/ActionTrip';

            return $http.apiPOST(actionTripUrl, requestData)
                .then(function({data}) {
                    tripUtils.setCardValidationUrls(tripDetails, data.CardValidationUrls);
                    return data;
                });
        },

        travelFusionProcessCreditCard: function(verificationId) {
            // TODO: It shouldn't be GET, POST most likely
            return $http.apiGET('/flights/TravelFusionProcessCreditCard', {
                params: {verificationId},
            });
        },
        acceptReview: function(tripId, acceptStatus) {
            return $http.apiGET('/trips/ApproveFeedbackReview', {
                params: {
                    tripId,
                    isAccepted: acceptStatus,
                },
            });
        },
        resendConfirmation,
        validatePaymentCode,
        validatePaymentCodeWithParent,
        getChildPaymentCodes,
    };

    function createFireEventFunction(event) {
        return function(data) {
            $rootScope.$emit(event, data);
        };
    }

    function resendConfirmation(tripId) {
                const endpoint = `${appCONST.apiUrl}/trips/resendConfirmation?tripId=${tripId}`;
                return $http.post(endpoint);
    }

    function validatePaymentCode(params) {
        return $http.apiGET('/staticData/ValidatePaymentCodeValue', {params, noSpinner: true})
            .then(({data}) => data);
    }

    function validatePaymentCodeWithParent({paymentCodeId, value, parentPaymentCodeId}, {tripId}) {
        return $http.apiGET(`/staticData/ValidatePaymentCodeValue?paymentCodeId=${paymentCodeId}&parentPaymentCodeSelectedValueId=${parentPaymentCodeId}&value=${value}&tripId=${tripId}`)
            .then(({data}) => data);
    }

    function getChildPaymentCodes({paymentCodeId, parentPaymentCodeId}) {
        return $http.apiGET(`/staticdata/GetChildPaymentCodes?paymentCodeId=${paymentCodeId}&parentPaymentCodeSelectedValueId=${parentPaymentCodeId}`)
            .then(({data}) => data);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/services/tripAPI.js